// extracted by mini-css-extract-plugin
export default {"description":"Overview_description__NROj6","feedback":"Overview_feedback__40jjU"};